import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

// Move this to environment.ts if you have one
const EXPORT_URL =
  "https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/bills/tagexcelstatus";

export interface ExportReport {
  lid_monthYear?: string;
  report_id?: string;
  account_id?: string;
  status: string; 
  tag_key?: string;
  tag_value?: string;
  started_at?: string;
  completed_at?: string | null;
  s3_bucket?: string;
  s3_key?: string;
  error?: string | null;
  url?: string;
  expires_in_seconds?: number;
  progress?: number; // optional, used if backend ever sends it
}

export interface StartExportPayload {
  account_ids: string;
  year: string;
  month: string;
  tag_key: string;
  tag_value: string; // "" for ALL
}

export interface StatusPayload {
  account_ids: string;
  year: string;
  month: string;
  tag_key: string;
  tag_value: string; // "ALL" when no tag value
}

@Injectable({ providedIn: "root" })
export class ExportService {
  constructor(private http: HttpClient) {}

  /** action + overwrite are always set here, so callers can't forget them */
  start(payload: StartExportPayload): Observable<any> {
    return this.http.post<any>(EXPORT_URL, {
      action: "generate",
      ...payload,
      overwrite: true,
    });
  }

  getStatus(payload: StatusPayload): Observable<ExportReport> {
    return this.http
      .post<any>(EXPORT_URL, { action: "status", ...payload })
      .pipe(
        map((res) => {
          const body = res?.response?.response ?? res?.response ?? res;
          const reports: ExportReport[] = body?.reports ?? [];
          if (!reports.length) return { status: "NOT_FOUND" };
          const wanted = payload.tag_value || "ALL";
          return reports.find((r) => r.tag_value === wanted) ?? reports[0];
        }),
      );
  }
}